import { VIZ_CATEGORICAL } from '@splunk/visualization-color-palettes';
import {
    COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    enhanceOptionsSchemaWithDynamicOptions,
    getPattern,
} from '../utils';

export const sankeyOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    backgroundColor: {
        default: '> themes.defaultBackgroundColor',
        description:
            'Specify the color for the background. You may use a dataSource to apply the color. The default for enterprise light is "#ffffff". The default for enterprise dark is "#000000". The default for prisma dark is "#0b0c0e".',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    colorMode: {
        default: 'categorical',
        description:
            'Specify the coloring method used for the links. When set to "categorical" the nodes and links will be colored based on the "seriesColors". When set to "dynamic" the links will be colored based on the dynamic string assigned to "linkColors".',
        pattern: getPattern(['categorical', 'dynamic']),
        type: 'string',
    },
    labelDisplay: {
        default: 'off',
        description:
            'Specify whether to display the values and/or percentages of the nodes. Values are abbreviated to two decimal points, and a magnitude unit will be displayed. Percentages are calculated using the maximum node value as 100%. For very small nodes (with height < 24px) the values/percentage display is automatically turned off. ',
        pattern: getPattern(['values', 'valuesAndPercentage', 'percentage', 'off']),
        type: 'string',
    },
    linkColors: {
        default: `> linkValues | rangeValue(linkColorRangeConfig)`,
        description:
            'Specify the coloring method used for the links when the colorMode “dynamic” is specified.',
        type: 'array',
        items: {
            type: 'string',
            pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        },
    },
    linkOpacity: {
        default: 0.5,
        description: 'Specify the opacity of the links. Choose a number in the range of 0 - 1 (inclusive).',
        type: 'number',
    },
    linkValues: {
        default: `> primary | seriesByType('number')`,
        description: 'Specify the dataSource to apply link width.',
        type: 'string',
    },
    resultLimit: {
        default: 1000,
        description: 'Specify the maximum length of link data points rendered.',
        type: 'number',
    },
    seriesColors: {
        default: VIZ_CATEGORICAL,
        description: 'Specify the colors used for a series. For example, ["#FF0000", "#0000FF", "#008000"].',
        type: 'array',
        items: {
            type: 'string',
        },
    },
    unit: {
        description:
            'Specify text to show on the left of the value in the node label when "labelDisplay" is set to either "values" or "valuesAndPercentage"',
        type: 'string',
    },
});
